(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["outletlet-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-ol-variant]')) return;
    var option = event.target.options[event.target.selectedIndex];
    var root = event.target.closest('.ol-home');
    var price = root.querySelector('[data-ol-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    var stickyPrice = root.querySelector('[data-ol-sticky-price]');
    var stickyVariant = root.querySelector('[data-ol-sticky-variant]');
    if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    if (stickyVariant) stickyVariant.value = option.value;
    var title = root.querySelector('.ol-offer__details h2');
    if (title && option.dataset.title) title.textContent = option.dataset.title;
    var image = root.querySelector('.ol-offer__media img');
    if (image && option.dataset.image && root.lang !== 'ja') { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    var summary = root.querySelector('.ol-sticky__summary span');
    if (summary && option.dataset.title) summary.textContent = option.dataset.title;
  });
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-ol-select]');
    if (!link) return;
    var select = link.closest('.ol-home').querySelector('[data-ol-variant]');
    if (select) { select.value = link.dataset.olSelect; select.dispatchEvent(new Event('change', {bubbles:true})); }
  });
  function updateOutletletSticky() {
    document.querySelectorAll('[data-ol-sticky]').forEach(function(sticky) {
      var button = sticky.closest('.ol-home').querySelector('.ol-product-form button');
      var rect = button ? button.getBoundingClientRect() : null;
      var offerVisible = rect && rect.top >= 0 && rect.bottom <= window.innerHeight;
      sticky.hidden = window.scrollY < window.innerHeight * 2 || offerVisible;
    });
  }
  window.addEventListener('scroll', updateOutletletSticky, { passive: true });
  window.addEventListener('resize', updateOutletletSticky);
  updateOutletletSticky();

  } catch(e) { console.error(e); }
})();
})();
